import { useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import LockIcon from '@mui/icons-material/Lock';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';

export default function FoldersDisplayItem(props) {
    const {item, currentUser, setTarget, target, 
        handleMenuClick, menuOpen, deleteItem, moveOut, moveIn, 
        type, input, setInput, handleRegenURL, defaultSkin, setSelector, menuRef} = props;
    const [confirmingClose, setConfirmingClose] = useState(false);

    function handleHeaderClick() {
        if (type === "pages") {
            if (target.method === "moveIn") {
                moveIn(target.movingItem.id, target.movingItem.type, [...target.path, item.id]);
            } else {
                setTarget(prev => ({
                    ...prev,
                    path: [...prev.path, item.id]
                }));
            }
        } else if (type === "skins") {
            if (item.type === "skin") {
                handleEditClick()
            } else if (target.method === "moveIn") {
                moveIn(target.movingItem.id, target.movingItem.type, [...target.path, item.id]);
            } else {
                setTarget(prev => ({
                    ...prev,
                    path: [...prev.path, item.id]
                }));
            }
        } else if (type === "skin-select") {
            if (item.type === "skin") {
                setInput(prevInput => ({
                    ...prevInput,
                    skinId: item.id
                }));
            } else {
                setSelector(prev => ([...prev, item.id]));
            }
        }
    }

    function handleEditClick() {
        // First, update the target path
        if (type === "pages") {
            setTarget(prev => {
                return { 
                    ...prev,
                    method: "edit",
                    editingItem: {
                    id: item.id,
                    title: item.title,
                    skinId: item.type === "page" ? item.skinId : item.defaultSkinId,
                    isPrivate: item.isPrivate,
                    isProfile: item.isProfile,
                    type: item.type,
                    order: item.order
                    }
                }; 
            });
        }else if (type === "skins") {
            if (item.type === "skin") {
                setTarget((prev) => ({
                    ...prev,
                    method: "edit",
                    editingItem: {
                            id: item.id,
                            authorId: item.authorId,
                            order: item.order,
                            title: item.title, 
                            folderId: item.folderId,
                            type: item.type,
                            groupWidth: item.groupWidth,
                            columnStart: item.columnStart,
                            columnEnd: item.columnEnd,
                            pageTitleFont: item.pageTitleFont, 
                            pageTitleColor:item.pageTitleColor, 
                            pageSubtitleFont: item.pageSubtitleFont,
                            pageSubtitleColor: item.pageSubtitleColor, 
                            pageBackgroundColor: item.pageBackgroundColor,
                            backgroundImage: item.backgroundImage,
                            curvedBorders: item.curvedBorders, 
                            groupBorders: item.groupBorders, 
                            blockBorders: item.blockBorders, 
                            borderColor: item.borderColor, 
                            titleBorderColor: item.titleBorderColor, 
                            groupBackgroundColor: item.groupBackgroundColor,
                            blockBackgroundColor: item.blockBackgroundColor, 
                            textFont: item.textFont, 
                            textSize: item.textSize, 
                            textColor: item.textColor, 
                            linkColor: item.linkColor, 
                            linkHoverColor: item.linkHoverColor
                        }
                }));
            } else {
                setTarget((prev) => ({
                    ...prev,
                    method: "edit",
                    editingItem: {
                            id: item.id,
                            authorId: item.authorId,
                            order: item.order,
                            title: item.title, 
                            type: item.type,
                            parentId: item.parentId
                        }
                }));
            }
        }
    }

    function handleDeleteClick() {
        deleteItem(item.type, item.id, item.order);
    }
    
    function handleMoveOut() {
        moveOut(item.id, item.type)
    }

    function handleMoveIn() {
        setTarget((prev) => ({
            ...prev,
            method: "moveIn",
            movingItem: {id: item.id, type:item.type}
        }));
    }

    function handleItemRegenURL() {
        handleRegenURL(item.id, item.order);
    }

    if (type === "pages") {
        return (
            <div className="folders-item" id={target.method==="moveIn" && target.movingItem.id === item.id && target.movingItem.type === item.type?"folders-item-selected":""}>
                {confirmingClose && 
                <div id="close-confirm">
                    <h2>are you sure you want to delete this?</h2>
                    <div>
                    <button className="block-type-option" onClick={() => {
                        setConfirmingClose(false)
                        handleDeleteClick()
                        }}>
                        OK
                    </button>
                    <button className="block-type-option" onClick={() => setConfirmingClose(false)}>Cancel</button>
                    </div>
                </div>}
                {item.type !== "page" &&
                <div onClick={handleHeaderClick} className="folders-item-header">
                    <h4>{item.title}</h4>
                </div>}
                {item.type === "page" &&
                <a href={item.isProfile === 1? `/profile/${currentUser.id}` :`/${currentUser.id}/page/${item.pageCode}`} className="folders-item-header">
                    <h4>{item.title}</h4>
                </a>}
                <div className="folders-item-footer">
                    <div className="folders-item-options" 
                        onClick={() => {handleMenuClick(item.id, item.type)}} 
                        ref={menuOpen.id === item.id && menuOpen.type === item.type ? menuRef : null}
                    >
                        <MoreVertIcon/>
                    </div>
                    {item.isPrivate === 1 && <div><LockIcon sx={{ fontSize: window.innerWidth < 600 ? "18px" : "24px" }}/></div>}
                    {item.type !== "page" && <div>
                        <InsertDriveFileIcon sx={{ fontSize: window.innerWidth < 600 ? "18px" : "24px" }}/>
                        {item.children?.length}
                    </div>
                    }
                    <p>{item.type}</p>
                </div>
                {menuOpen.id === item.id && menuOpen.type === item.type && <div className="folders-item-menu" ref={menuOpen.id === item.id && menuOpen.type === item.type ? menuRef : null}>
                    <div onClick={() => {handleEditClick(); handleMenuClick(item.id, item.type)}}><EditIcon /> Configure</div>
                    {item.type === "page" && item.isProfile === 0 && item.id !== 1 && <div onClick={() => {handleItemRegenURL(); handleMenuClick(item.id, item.type)}}><RotateLeftIcon /> RegenURL</div>}
                    {item.isProfile !== 1 && <div onClick={() => {handleMoveIn(); handleMenuClick(item.id, item.type)}}><DriveFileMoveIcon /> Move Into</div>}
                    {target.path.length > 0 && <div onClick={() => {handleMoveOut(); handleMenuClick(item.id, item.type)}}><ExitToAppIcon /> Move out</div>}
                    {item.isProfile !== 1 && <div onClick={() => {setConfirmingClose(true); handleMenuClick(item.id, item.type)}}><DeleteIcon /> Delete</div>}
                </div>}
            </div>
        )
    } else if (type === "skins") {
        return (
            <div className="folders-item" id={target.method==="moveIn" && target.movingItem.id === item.id && target.movingItem.type === item.type?"folders-item-selected":""}>
                {confirmingClose && 
                <div id="close-confirm">
                    <h2>are you sure you want to delete this?</h2>
                    <div>
                    <button className="block-type-option" onClick={() => {
                        setConfirmingClose(false)
                        handleDeleteClick()
                        }}>
                        OK
                    </button>
                    <button className="block-type-option" onClick={() => setConfirmingClose(false)}>Cancel</button>
                    </div>
                </div>}
                {item.type !== "skin" &&
                <div onClick={handleHeaderClick} className="folders-item-header">
                    <h4>{item.title}</h4>
                </div>}
                {item.type === "skin" &&
                <div onClick={handleHeaderClick} className="folders-item-header">
                    <h4>{item.title}</h4>
                </div>}
                <div className="folders-item-footer">
                    <div className="folders-item-options" onClick={() => {handleMenuClick(item.id, item.type)}}><MoreVertIcon/></div>
                    {item.type !== "skin" && <div><InsertDriveFileIcon sx={{ fontSize: window.innerWidth < 600 ? "18px" : "24px" }}/>{item.children?.length}</div>}
                    {item.type === "skin" ? <p>skin</p> : <p>skin folder</p>}
                </div>
                {menuOpen.id === item.id && menuOpen.type === item.type && <div className="folders-item-menu">
                    <div onClick={() => {handleEditClick(); handleMenuClick(item.id, item.type)}}><EditIcon /> Configure</div>
                    <div onClick={() => {handleMoveIn(); handleMenuClick(item.id, item.type)}}><DriveFileMoveIcon /> Move Into</div>
                    {target.path.length > 0 && <div onClick={() => {handleMoveOut(); handleMenuClick(item.id, item.type)}}><ExitToAppIcon /> Move out</div>}
                    {(item.type !== "skin" || item.id !== defaultSkin) && <div onClick={() => {setConfirmingClose(true); handleMenuClick(item.id, item.type)}}><DeleteIcon /> Delete</div>}
                </div>}
            </div>
        )
    } else if (type === "skin-select") {
        return (
            <div onClick={handleHeaderClick} className="folders-item" id={type==="skin-select" && input.skinId === item.id && item.type === "skin" ? "folders-item-selected" : ""}>
                <div className="folders-item-header">
                    <h4>{item.title}</h4>
                </div>
                <div className="folders-item-footer">
                    {item.type !== "skin" && <div style={{paddingRight: window.innerWidth > 600 ? "10px" : "2px"}}><InsertDriveFileIcon sx={{ fontSize: window.innerWidth < 600 ? "18px" : "24px" }}/>{item.children?.length}</div>}
                    {item.type === "skin" ? <p>skin</p> : <p>skin folder</p>}
                </div>
            </div>
        )
    }
}